/**
 * Styled Components - Created by david on 28/02/18.
 */
import styled from 'styled-components'
import Tooltip from 'antd/lib/tooltip'
import { BLUE, GRAY_LIGHTEST } from '../../../theme/colors'
import Collapse from 'antd/lib/collapse/Collapse'

type StyledProps = {
  color?: string
  secondary?: boolean
}

export const Container = styled.div`
  padding-top: ${({ secondary }: StyledProps) => secondary ? '0px' : '10px'};
  margin-top: ${({ secondary }: StyledProps) => secondary ? '-12px' : 'unset'};
`

export const StyledCollapse = styled(Collapse)`
  border: unset;
  .ant-collapse-item {
    border: unset;
  }
  .ant-collapse-header {
    font-weight: bold;
    font-family: Avenir;
    background: white;
    padding: 12px 0 12px 30px;
  }
  .anticon-right {
    left: 154px !important;
    top: 26px !important;
  }
`

export const HeaderIcon = styled.img`
  max-width: 18px;
  margin-top: -4px;
  margin-right: 8px;
  margin-left: -18px;
`

export const PaletteContainer = styled.div`
  padding: ${({ secondary }: StyledProps) => secondary ? 'unset' : '8px 18px'};
  padding-bottom: ${({ secondary }: StyledProps) => secondary ? '16px' : '20px'};
  position: relative;
  transition: opacity 0.3s ease;
  &:hover {
    opacity: 0.8;
    cursor: pointer;
  }
  &::after {
    content: "";
    width: 98%;
    height: 1px;
    background-color: ${GRAY_LIGHTEST};
    position: absolute;
    bottom: 0;
    left: 0;
  }
`

export const ColorBar = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`

export const LegendText = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 6px;
  font-weight: bold;
  font-family: Avenir;
  padding-left: 4px;
  justify-content: space-between;
`

export const ShareButton = styled.div`
  color: cornflowerblue;
  font-weight: normal;
  font-size: 12px;
  border-radius: 3px;
  padding: 0 12px;
  align-self: flex-end;
  transition: all .25s;
  @media (max-width: 768px) {
    margin-right: 22px;
    font-size: 14px;
  }
  &:hover {
    cursor: pointer;
    background: cornflowerblue;
    color: white;
  }
`

export const ApplyButton = styled.div`
  border: 1px solid ${BLUE};
  font-size: 12px;
  padding: 0 16px;
  border-radius: 3px;
  color: ${BLUE};
  font-weight: normal;
`

export const Bar = styled.div`
  display: flex;
  width: 100%;
  height: 34px;
  border-radius: 5px;
  overflow: auto;
  box-shadow: 1px 2px 4px -2px #989898;
`

export const ColorContent = styled.div`
  display: flex;
  flex: 1;
  position: relative;
  ${({ secondary }: StyledProps) => secondary ? `
    max-width: 40%;
  ` : ''}
`

export const ColorLabel = styled.div`
  position: absolute;
  bottom: 5px;
  left: 20px;
  font-size: 10px;
`

export const Color = styled.div`
  width: 100%;
  background-color: ${({ color }: StyledProps) => color || 'none'};
  ${({ color }: StyledProps) => color === '#FFFFFF' ? `
    border-top: 1px solid lightgray;
    border-left: 1px solid whitesmoke;
  ` : ''}
`

export const StyledPopOver = styled(Tooltip)``


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterCustomize/TrendPalettes/styledComponents.tsx